import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const faqs = [
    {
      question: 'How do I return my Hot Charge power bank?',
      answer: `Returning your Hot Charge power bank is quick and easy! Just follow these steps:<br/><br/>
      <b>1. Locate a Hot Charge Kiosk:</b>&nbsp;Find the nearest Hot Charge kiosk using our app or website.<br/><br/>
      <b>2. Insert the Power Bank:</b>&nbsp;At the kiosk, simply insert the power bank into an empty slot. Ensure the power bank is properly aligned and slides in smoothly.<br/><br/>
      <b>3. Confirmation:</b>&nbsp;Wait for the kiosk to recognize and confirm the return. You will see a confirmation message on the screen and receive a notification on your app.<br/><br/>
      <b>4. Check Your App:</b>&nbsp;Verify that the return has been successfully processed in the Hot Charge app. Your rental session will be closed, and any remaining balance will be settled.
      <br /><br />If you encounter any issues or have further questions, please contact our customer support team for assistance.`
    },
    {
      question: 'Is Hot Charge Power Banks Water Proof?',
      answer: 'Hot Charge power banks are not waterproof. They are designed to be durable and withstand normal usage conditions, but they are not specifically waterproof.'
    },
    {
      question: 'Can I rent multiple Hot Charge power banks at a time?',
      answer: 'Yes, you can rent multiple Hot Charge power banks at a time.'
    },
    {
      question: 'Are cash payments allowed?',
      answer: 'No, cash payments are not allowed for Hot Charge power bank rentals. All transactions must be completed using our secure digital payment methods to ensure a smooth and hassle-free experience.'
    },
    {
      question: 'How secure are Hot Charge power banks?',
      answer: 'Hot Charge power banks are highly secure. They are equipped with advanced safety features, including overcharge protection, short circuit protection, and temperature control, ensuring a safe and reliable charging experience for your devices.'
    },
    {
      question: 'Can I travel to other cities or countries with Hot Charge power banks?',
      answer: 'Yes, you can travel to other cities or countries with a Hot Charge power bank where Hot Charge kiosks will be available. However, please ensure you comply with airline regulations regarding carrying portable chargers and power banks in your luggage.'
    },
    {
      question: 'What to do when unable to receive OTP or change password?',
      answer: `If you are unable to receive an OTP or change your password for your Hot Charge account, please follow these steps:
      <br /><br /><b>1. Check Network Connection:</b>&nbsp;Ensure your device has a stable internet connection.
      <br /><br /><b>2. Verify Phone Number/Email:</b>&nbsp;Confirm that you have entered the correct phone number or email address.
      <br /><br /><b>3. Resend OTP:</b>&nbsp;Try resending the OTP after waiting for a few minutes.
      <br /><br /><b>4. Check Spam/Junk Folder:</b>&nbsp;f using email, check your spam or junk folder for the OTP.
      <br /><br /><b>5. Contact Support:</b>&nbsp;If the issue persists, contact our customer support team for assistance. They can help you troubleshoot the problem and guide you through the process.
      <br /><br />You can reach our customer support at info@hotcharge.com or call us at +91 9115111899.`
    },
    {
      question: 'Why has my rental session not ended despite returning the power bank?',
      answer: `If your rental session has not ended despite returning the power bank, please follow these steps:
      <br /><br /><b>1. Check Return Confirmation:</b> &nbsp;Ensure you received a return confirmation on the kiosk screen or via SMS/email.
      <br /><br /><b>2. Confirm Correct Return:</b> &nbsp;Verify that you returned the power bank to the correct Hot Charge kiosk.
      <br /><br /><b>3. Wait a Few Minutes:</b> &nbsp;Sometimes it may take a few minutes for the system to process the return.
      <br /><br /><b>4. Contact Support:</b> &nbsp;If the session still has not ended, contact our customer support team for assistance. Provide them with the kiosk location, return time, and any confirmation details you have.
      <br /><br />You can reach our customer support at info@hotcharge.com or call us at +91 9115111899.`
    },
    {
      question: 'Who are we?',
      answer: 'Hot Charge is a leading provider of power bank rental kiosks, offering convenient and reliable charging solutions for customers on the go. Our kiosks are strategically located in various cities and countries, making it easy for you to rent and return power banks wherever you are. We prioritize safety, ease of use, and customer satisfaction, ensuring you always stay powered up.'
    },
    {
      question: 'What happens if I lose or damage a Hot Charge power bank?',
      answer: 'If you lose or damage a Hot Charge power bank, please contact our customer support team immediately. You may be charged a fee based on the terms of our rental agreement. Our support team will guide you through the process and provide further instructions.'
    }
  ];

  return (
    <div id="faq" className="FAQ">
      <h1 className="FAQ-heading">Frequently asked questions</h1>
      <div className="faq-container">
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <div className="faq-question" onClick={() => toggleAnswer(index)}>
              {faq.question}
              <span className={`arrow ${openIndex === index ? 'open' : ''}`}>&#9662;</span>
            </div>
            {openIndex === index && <div className="faq-answer"
              dangerouslySetInnerHTML={{ __html: faq.answer }}
            ></div>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;



// WEBPACK FOOTER //
// ./src/components/FAQ/FAQ.js